import { Quaternion, Vector3 } from 'three';
import { Entity } from './Entity.js';
import { GROUP, MASK } from '../physics/groups.js';

/**
 * A generic mesh + rigid body pair. Level props, crates, platforms and balls
 * are all Props with different shapes and masses.
 */
export class Prop extends Entity {
  constructor({
    physics,
    mesh,
    shape,
    mass = 0,
    position = [0, 0, 0],
    quaternion = [0, 0, 0, 1],
    friction = 0.7,
    restitution = 0,
    linearDamping = 0,
    angularDamping = 0.1,
    lockRotation = false,
    kinematic = false,
    group = GROUP.PROP,
    mask = MASK.PROP,
    userData = null,
  }) {
    super({ mesh });

    this.initialPosition = new Vector3(position[0], position[1], position[2]);
    this.initialQuaternion = new Quaternion(quaternion[0], quaternion[1], quaternion[2], quaternion[3]);

    this.body = physics.addBody({
      shape,
      mass,
      position,
      quaternion,
      mesh,
      friction,
      restitution,
      linearDamping,
      angularDamping,
      lockRotation,
      kinematic,
      group,
      mask,
      userData: { type: 'prop', entity: this, ...userData },
    });
  }

  /** Put a prop back where it started. Handy while iterating on a level. */
  reset() {
    this.body.teleport(this.initialPosition, this.initialQuaternion);
  }
}
